// src/components/layout/Layout.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Never leave the mobile drawer covering the page you just navigated to.
  useEffect(() => setDrawerOpen(false), [location.pathname, location.search]);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-bg">
      <Navbar onMenuClick={() => setDrawerOpen(true)} />

      <div className="mx-auto flex w-full max-w-[1440px]">
        {/* Rail: always present on desktop, a drawer on small screens */}
        <aside className="sticky top-[60px] hidden h-[calc(100vh-60px)] w-[246px] flex-none lg:block">
          <Sidebar />
        </aside>

        {drawerOpen && (
          <div className="fixed inset-0 z-50 lg:hidden">
            <div
              className="absolute inset-0 bg-ink/50"
              onClick={() => setDrawerOpen(false)}
              aria-hidden="true"
            />
            <div className="absolute inset-y-0 left-0 w-[262px] bg-surface shadow-modal">
              <Sidebar onNavigate={() => setDrawerOpen(false)} />
            </div>
          </div>
        )}

        <main className="min-w-0 flex-1 px-4 py-6 pb-16 lg:px-7">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
